import { useEffect, useState } from "react";
import { OpcoesACFinfosFNZ } from "../../types/OpcoesACFinfosFNZ";
import styles from "./styles.module.scss";
import Logo from "../../public/static-next/logo-finanzero.svg";
import Telefone from "../../public/static-next/icons/telefone.svg";
import Facebook from "../../public/static-next/icons/facebook-footer.svg";
import Linkedin from "../../public/static-next/icons/linkedin-footer.svg";
import Instagram from "../../public/static-next/icons/instagram.svg";
import Youtube from "../../public/static-next/icons/youtube.svg";
import Award from "../../public/static-next/icons/selo-verde-campea.svg";
import { FooterTypes } from "../../types/Footer";
import Script from "next/script";
import Link from "next/link";

export const Footer = ({
  footerMenu,
  sidebarRodape2,
  stringData,
  footerOptions,
}: FooterTypes) => {
  const [companyInfos, setcompanyInfos] = useState<OpcoesACFinfosFNZ>();

  useEffect(() => {
    if (stringData) {
      const toJSON = stringData.replace(/(<([^>]+)>)/gi, "");
      setcompanyInfos(JSON.parse(toJSON));
    }
  }, [stringData]);

  function NavLink({ item }) {
    const { text, link, targetblank } = item;

    const linkProps = {
      href: link,
      className: styles.nav_link,
      targetblank: targetblank ? "_blank" : "_self",
    };

    return (
      <li className={styles.nav_item}>
        <Link prefetch={false} {...linkProps}>
          {text}
        </Link>
      </li>
    );
  }

  function GroupMenu({ groupProps }) {
    const { text, menuitems, link, targetblank } = groupProps;

    const linkTitleProps = {
      href: link,
      children: text,
      targetblank: targetblank ? "_blank" : "_self",
    };

    return (
      <div className={styles.footer_menu}>
        <div className="navigation-category widget_nav_menu">
          <h4 className={styles.widgettitle}>
            {link ? <Link {...linkTitleProps} prefetch={false} /> : text}
          </h4>
          <ul className="menu">
            {menuitems &&
              menuitems.length > 0 &&
              menuitems.map((item, index) => {
                return <NavLink item={item} key={index} />;
              })}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <footer className={styles.footer}>
      <div className={styles.footer_topbar}>
        <div className={[styles.footer_row, styles.row].join(" ")}>
          <div
            className={[styles.footer_navigations, styles.footer_column].join(
              " "
            )}
          >
            {footerMenu &&
              footerMenu.length > 0 &&
              footerMenu.map((itemColumn, indexColumn) => {
                return (
                  <div className={styles.footer_menu} key={indexColumn}>
                    {itemColumn?.column.length > 0 &&
                      itemColumn.column.map((item, index) => {
                        return (
                          <GroupMenu groupProps={item.grupo} key={index} />
                        );
                      })}
                  </div>
                );
              })}
          </div>

          <div className={styles.footer_second_row}>
            <div
              className={[styles.footer_info, styles.footer_column].join(" ")}
            >
              <div className={styles.footer_logo}>
                <Logo title={"Logo FinanZero"} />
              </div>

              <p className={styles.footer_info_enterprise}>
                {companyInfos?.company} CNPJ/MF {companyInfos?.cnpj}
              </p>
              <p className={styles.footer_address}>
                {companyInfos?.address} - CEP: {companyInfos?.postalCode}
              </p>

              <div className={styles.contact_complain}>
                <p className={styles.contact_complain__description}>
                  {footerOptions?.textSac}
                  <br />
                  <Link
                    prefetch={false}
                    href={`mailto:${footerOptions?.emailSac}`}
                    className={[styles.nav_link, styles.link_complain].join(
                      " "
                    )}
                  >
                    {footerOptions?.emailSac}
                  </Link>
                </p>
                <p className={styles.contact_complain__description}>
                  {footerOptions?.textPress}
                  <br />
                  <Link
                    prefetch={false}
                    href={`mailto:${footerOptions?.emailPress}`}
                    className={[styles.nav_link, styles.link_complain].join(
                      " "
                    )}
                  >
                    {footerOptions?.emailPress}
                  </Link>
                </p>
              </div>

              <div className={styles.contact_infos}>
                <div className={styles.contact_infos_icon}>
                  <Telefone />
                </div>

                <div className={styles.contact_infos_content}>
                  <Link
                    href={`tel:${companyInfos?.phone}`}
                    className={styles.contact_infos_tel}
                  >
                    {companyInfos?.phone}
                  </Link>
                  <p className={styles.contact_infos_hours}>
                    {companyInfos?.hours}
                  </p>
                </div>
              </div>
            </div>
            <div className={[styles.social, styles.footer_column].join(" ")}>
              <div className={styles.footer_social}>
                <div
                  id="custom_html-2"
                  className={[
                    styles.widget_text,
                    styles.text_descript,
                    styles.widget_custom_html,
                  ].join(" ")}
                >
                  <h4 className={styles.navigation_category_title}>
                    SIGA A GENTE
                  </h4>
                  <div
                    className={[
                      styles.textwidget,
                      styles.custom_html_widget,
                    ].join(" ")}
                  >
                    <ul className={styles.social_list}>
                      <li>
                        <Link
                          prefetch={false}
                          className={styles.social_item_link}
                          href="https://www.facebook.com/finanzero/"
                          rel="noopener"
                          aria-label="Facebook"
                        >
                          <Facebook />
                        </Link>
                      </li>
                      <li>
                        <Link
                          prefetch={false}
                          className={styles.social_item_link}
                          href="https://www.linkedin.com/company/finanzero/"
                          rel="noopener"
                          aria-label="Linkedin"
                        >
                          <Linkedin />
                        </Link>
                      </li>
                      <li>
                        <Link
                          prefetch={false}
                          className={styles.social_item_link}
                          href="https://www.instagram.com/finanzero/"
                          rel="noopener"
                          aria-label="Instagram"
                        >
                          <Instagram />
                        </Link>
                      </li>
                      <li>
                        <Link
                          prefetch={false}
                          className={styles.social_item_link}
                          href="https://www.youtube.com/finanzero"
                          rel="noopener"
                          aria-label="YouTube"
                        >
                          <Youtube />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className={styles.selosWrapper}>
                <div id="reputation-ra" className={styles.seloReclameAqui}>
                  <Script
                    src="https://s3.amazonaws.com/raichu-beta/selos/bundle.js"
                    strategy="lazyOnload"
                    onReady={() => {
                      const raScript = document.createElement("script");

                      raScript.setAttribute(
                        "src",
                        "https://s3.amazonaws.com/raichu-beta/selos/bundle.js"
                      );
                      raScript.setAttribute("id", "ra-embed-reputation");
                      raScript.setAttribute(
                        "data-id",
                        "MTYwMDU0OmZpbmFuemVybw=="
                      );
                      raScript.setAttribute("data-target", "reputation-ra");
                      raScript.setAttribute("data-model", "2");
                      document.head.appendChild(raScript);
                    }}
                  />
                </div>
                <Award className={styles.reclameAward} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={styles.footer_bottombar}>
        <div className={styles.row}>
          <div className={styles.footer_important}>
            {sidebarRodape2?.length > 0 &&
              sidebarRodape2?.map((item) => {
                return (
                  <div
                    key={item.databaseId}
                    dangerouslySetInnerHTML={{ __html: item.html }}
                  />
                );
              })}
          </div>
        </div>
      </div>
    </footer>
  );
};
